export default __webpack_public_path__ + "static/media/sa-9.06092174.png";